import SplitType from 'split-type'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'split-text',

  componentDidMount () {
    setTimeout(() => {
      this.text = new SplitType(this.el, { types: 'words, lines' })
    }, 500)
  },
})
